import React, { Component } from 'react';
import Footer from '../../components/common/global_layout/footer';
import Sharedheader from '../../components/Admin/sharedHeader';
import PagePath from '../../components/common/pagePath';
import { Button, Container } from 'reactstrap';
import DashTab from '../../components/Admin/dashTab';
import "../../style/css/pro/Admin.css"
class Notifications extends Component {
    render() {
        return (
            <>
                
                <Container className='mb-5 pb-5'>
                   <PagePath pages={['Acceuil', "Notifications"]}/>
                   <Sharedheader name="Notifications" icon="/imgs/dashboard/big_notif.svg"/>
                   <div className="mt-3 notification__container container">
                       <DashTab small items={["Commandes", "Toutes"]} content={[]}/>
                   </div>
                   <div className="notification__list container">
                       <div className="notification__card d-flex justify-content-between">
                           <div className="d-flex align-items-center">
                                <img src="/imgs/dashboard/newNotif.svg" className='mr-2' width="15px" alt="" />
                                <img src="/imgs/dashboard/com.jpg" style={{borderRadius : "50%"}} className='mr-3' alt="" width="70px" />
                                <div>
                                    <h6 className='Cell'><b>Nouvelle commande : Location BMW X5</b></h6>
                                    <h6 className='Cell'><b>réservation du 01/05/2022 au 05/05/2022.</b></h6>
                                </div>
                           </div>
                           <div className="d-flex align-items-center">
                               <Button id='ntf'>Détails</Button>
      
                               <div>
                                   <h6 className='Cell'>2m</h6>
                                   <img src="/imgs/dashboard/points__horizon.svg" width="20px" alt="" />
                               </div>
                           </div>
                           
                       </div>
                       <div className="notification__card d-flex justify-content-between">
                           <div className="d-flex align-items-center">
                                <img src="/imgs/dashboard/newNotif.svg" className='mr-2' width="15px" alt="" />
                                <img src="/imgs/dashboard/com.jpg" style={{borderRadius : "50%"}} className='mr-3' alt="" width="70px" />
                                <div>
                                    <h6 className='Cell'><b>Nouvelle commande : Location BMW X5</b></h6>
                                    <h6 className='Cell'><b>réservation du 01/05/2022 au 05/05/2022.</b></h6>
                                </div>
                           </div>
                           <div className="d-flex align-items-center">
                               <Button id='ntf'>Détails</Button>
      
                               <div>
                                   <h6 className='Cell'>2m</h6>
                                   <img src="/imgs/dashboard/points__horizon.svg" width="20px" alt="" />
                               </div>
                           </div>
                           
                       </div>
                       <div className="notification__card d-flex justify-content-between">
                           <div className="d-flex align-items-center">
                                <img src="/imgs/dashboard/newNotif.svg" className='mr-2' width="15px" alt="" />
                                <img src="/imgs/dashboard/com.jpg" style={{borderRadius : "50%"}} className='mr-3' alt="" width="70px" />
                                <div>
                                    <h6 className='Cell'><b>Nouvelle commande : Location BMW X5</b></h6>
                                    <h6 className='Cell'><b>réservation du 01/05/2022 au 05/05/2022.</b></h6>
                                </div>
                           </div>
                           <div className="d-flex align-items-center">
                               <Button id='ntf'>Détails</Button>
      
                               <div>
                                   <h6 className='Cell'>2m</h6>
                                   <img src="/imgs/dashboard/points__horizon.svg" width="20px" alt="" />
                               </div>
                           </div>
                           
                       </div>
                       <div className="notification__card d-flex justify-content-between">
                           <div className="d-flex align-items-center">
                                <img src="/imgs/dashboard/newNotif.svg" className='mr-2' width="15px" alt="" />
                                <img src="/imgs/dashboard/com.jpg" style={{borderRadius : "50%"}} className='mr-3' alt="" width="70px" />
                                <div>
                                    <h6 className='Cell'><b>Nouvelle commande : Location BMW X5</b></h6>
                                    <h6 className='Cell'><b>réservation du 01/05/2022 au 05/05/2022.</b></h6>
                                </div>
                           </div>
                           <div className="d-flex align-items-center">
                               <Button id='ntf'>Détails</Button>
      
                               <div>
                                   <h6 className='Cell'>2m</h6>
                                   <img src="/imgs/dashboard/points__horizon.svg" width="20px" alt="" />
                               </div>
                           </div>
                           
                       </div>
                   </div>
                </Container>
                <Footer />
            </>
        );
    }
}

export default Notifications;
